import { Sample1009300 } from "./Sample1009300";
import { Sample1079869 } from "./Sample1079869";
import { Sample1089200 } from "./Sample1089200";
import { Sample196593 } from "./Sample196593";
import { Sample393485 } from "./Sample393485";
import { Sample780099 } from "./Sample780099";
import { Sample872699 } from "./Sample872699";

function Analysis() {
  return (
    <section id="Analysis">
      <h2>Analysis</h2>
      <h3 id="TokenPredictions">Token Predictions</h3>
      <p>
        Features in the last SAE layer can be used to predict the next token in a sequence. Groups
        of features collectively respond to specific patterns that identify “similar samples” within
        a dataset. By analyzing these samples, we can generate a probability distribution and
        compare it to the one produced by an LLM.
      </p>
      <Sample780099 />
      <Sample1009300 />
      <Sample1089200 />
      <h3 id="FeatureInteractions">Feature Interactions</h3>
      <p>
        Features in the intermediate layers work together to influence downstream features. These
        intermediate features respond to simple patterns at specific locations. Through
        self-attention and the feedforward network, downstream features build on upstream ones to
        create activations that represent more complex concepts.
      </p>
      <Sample872699 />
      <Sample393485 />
      <h3 id="TokenEmbeddings">Token Embeddings</h3>
      <p>
        The features representing token embeddings provide the atomic components used to construct
        more complex behaviors. Token embeddings encode information about (i) what a token
        represents and (ii) where a token is located.
      </p>
      <p>
        Generally, each non-positional feature is triggered by a specific token (or “letter” as it
        pertains to the character-based models being studied); however, some features fire upon
        encountering certain sets of vowels or punctuation marks.
      </p>
      <p>
        Features representing position encodings adhere to the sinusoidal patterns others have
        discovered. Positional features commonly exhibit peak activations in fewer than a dozen
        places. When firing together, these features can identify the exact location of specific
        tokens.
      </p>
      <Sample1079869 />
      <Sample196593 />
    </section>
  );
}

export { Analysis };
